module.exports = __webpack_public_path__ + "static/cyberbus-6a3d33881e03fe2819259183e4400ad7.png";